<template>
  <div :class="['paotang-container', { 'qr-mode': showQRCode || showConsent }]">
    <!-- QR Code Screen -->
    <div v-if="showQRCode" class="qr-screen">
      <div class="qr-card">
        <div class="qr-card-header">
          <span>ยืนยันตัวตนผ่านแอปพลิเคชั่นเป๋าตัง</span>
        </div>
        <div class="qr-card-divider"></div>
        <div class="qr-card-content" @click="handleQRCodeClick">
        <div class="qr-box">
          <div class="qr-corner qr-corner--tl"></div>
          <div class="qr-corner qr-corner--tr"></div>
          <div class="qr-corner qr-corner--bl"></div>
          <div class="qr-corner qr-corner--br"></div>
          <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" class="qr-svg">
            <!-- Top-left finder pattern -->
            <rect x="10" y="10" width="60" height="60" fill="none" stroke="#1a1a1a" stroke-width="8"/>
            <rect x="24" y="24" width="32" height="32" fill="#1a1a1a"/>
            <!-- Top-right finder pattern -->
            <rect x="130" y="10" width="60" height="60" fill="none" stroke="#1a1a1a" stroke-width="8"/>
            <rect x="144" y="24" width="32" height="32" fill="#1a1a1a"/>
            <!-- Bottom-left finder pattern -->
            <rect x="10" y="130" width="60" height="60" fill="none" stroke="#1a1a1a" stroke-width="8"/>
            <rect x="24" y="144" width="32" height="32" fill="#1a1a1a"/>
            <!-- Data modules -->
            <rect x="84" y="10" width="8" height="8" fill="#1a1a1a"/>
            <rect x="100" y="10" width="8" height="8" fill="#1a1a1a"/>
            <rect x="84" y="26" width="8" height="8" fill="#1a1a1a"/>
            <rect x="116" y="26" width="8" height="8" fill="#1a1a1a"/>
            <rect x="92" y="42" width="8" height="8" fill="#1a1a1a"/>
            <rect x="108" y="42" width="8" height="8" fill="#1a1a1a"/>
            <rect x="84" y="58" width="8" height="8" fill="#1a1a1a"/>
            <rect x="100" y="58" width="8" height="8" fill="#1a1a1a"/>
            <rect x="116" y="58" width="8" height="8" fill="#1a1a1a"/>
            <rect x="10" y="84" width="8" height="8" fill="#1a1a1a"/>
            <rect x="26" y="84" width="8" height="8" fill="#1a1a1a"/>
            <rect x="42" y="84" width="8" height="8" fill="#1a1a1a"/>
            <rect x="58" y="84" width="8" height="8" fill="#1a1a1a"/>
            <rect x="84" y="84" width="8" height="8" fill="#1a1a1a"/>
            <rect x="108" y="84" width="8" height="8" fill="#1a1a1a"/>
            <rect x="132" y="84" width="8" height="8" fill="#1a1a1a"/>
            <rect x="148" y="84" width="8" height="8" fill="#1a1a1a"/>
            <rect x="164" y="84" width="8" height="8" fill="#1a1a1a"/>
            <rect x="180" y="84" width="8" height="8" fill="#1a1a1a"/>
            <rect x="10" y="100" width="8" height="8" fill="#1a1a1a"/>
            <rect x="42" y="100" width="8" height="8" fill="#1a1a1a"/>
            <rect x="84" y="100" width="8" height="8" fill="#1a1a1a"/>
            <rect x="100" y="100" width="8" height="8" fill="#1a1a1a"/>
            <rect x="124" y="100" width="8" height="8" fill="#1a1a1a"/>
            <rect x="148" y="100" width="8" height="8" fill="#1a1a1a"/>
            <rect x="172" y="100" width="8" height="8" fill="#1a1a1a"/>
            <rect x="18" y="116" width="8" height="8" fill="#1a1a1a"/>
            <rect x="50" y="116" width="8" height="8" fill="#1a1a1a"/>
            <rect x="92" y="116" width="8" height="8" fill="#1a1a1a"/>
            <rect x="116" y="116" width="8" height="8" fill="#1a1a1a"/>
            <rect x="140" y="116" width="8" height="8" fill="#1a1a1a"/>
            <rect x="164" y="116" width="8" height="8" fill="#1a1a1a"/>
            <rect x="180" y="116" width="8" height="8" fill="#1a1a1a"/>
            <rect x="84" y="130" width="8" height="8" fill="#1a1a1a"/>
            <rect x="100" y="130" width="8" height="8" fill="#1a1a1a"/>
            <rect x="124" y="130" width="8" height="8" fill="#1a1a1a"/>
            <rect x="148" y="130" width="8" height="8" fill="#1a1a1a"/>
            <rect x="172" y="130" width="8" height="8" fill="#1a1a1a"/>
            <rect x="84" y="148" width="8" height="8" fill="#1a1a1a"/>
            <rect x="116" y="148" width="8" height="8" fill="#1a1a1a"/>
            <rect x="140" y="148" width="8" height="8" fill="#1a1a1a"/>
            <rect x="164" y="148" width="8" height="8" fill="#1a1a1a"/>
            <rect x="84" y="164" width="8" height="8" fill="#1a1a1a"/>
            <rect x="100" y="164" width="8" height="8" fill="#1a1a1a"/>
            <rect x="132" y="164" width="8" height="8" fill="#1a1a1a"/>
            <rect x="156" y="164" width="8" height="8" fill="#1a1a1a"/>
            <rect x="180" y="164" width="8" height="8" fill="#1a1a1a"/>
            <rect x="84" y="180" width="8" height="8" fill="#1a1a1a"/>
            <rect x="108" y="180" width="8" height="8" fill="#1a1a1a"/>
            <rect x="124" y="180" width="8" height="8" fill="#1a1a1a"/>
            <rect x="148" y="180" width="8" height="8" fill="#1a1a1a"/>
            <rect x="172" y="180" width="8" height="8" fill="#1a1a1a"/>
          </svg>
        </div>
        <div class="qr-instruction">
          <p class="qr-instruction-text">กรุณา Scan QR Code</p>
          <p class="qr-instruction-subtext">เพื่อยืนยันตัวตนผ่านแอปพลิเคชั่นเป๋าตัง</p>
        </div>
        </div>
      </div>
    </div>

    <!-- Consent Screen -->
    <div v-if="showConsent" class="consent-screen">
      <div class="consent-card">
        <div class="consent-card-header">
          <span>ข้อกำหนดและเงื่อนไขการใช้บริการ</span>
        </div>
        <div class="consent-card-divider"></div>
        <div class="consent-card-content">
          <div class="consent-text-area">
            <p class="consent-text-title">การให้ความยินยอมในการประมวลผลข้อมูลส่วนบุคคล</p>
            <p class="consent-text-body">
              เพื่อการยืนยันตัวตนผ่านแอปพลิเคชั่นเป๋าตัง บริษัทนายทะเบียนหลักทรัพย์ขอความยินยอมจากท่านในการประมวลผลข้อมูลส่วนบุคคล ดังนี้
            </p>
            <ul class="consent-list">
              <li>การยืนยันตัวตนด้วยเลขที่บัตรประจำตัวประชาชนผ่านแอปพลิเคชั่นเป๋าตัง เพื่อเข้าใช้บริการดาวน์โหลดเอกสารทางการเงิน</li>
              <li>การประมวลผลข้อมูลส่วนบุคคล ได้แก่ ชื่อ-นามสกุล และเลขที่บัตรประจำตัวประชาชน เพื่อวัตถุประสงค์ในการให้บริการเท่านั้น</li>
              <li>บริษัทจะเก็บรักษาข้อมูลส่วนบุคคลของท่านด้วยมาตรการรักษาความปลอดภัยที่เหมาะสม และจะไม่เปิดเผยต่อบุคคลภายนอก เว้นแต่จะได้รับความยินยอมจากท่านหรือเป็นไปตามที่กฎหมายกำหนด</li>
              <li>ท่านสามารถเพิกถอนความยินยอมได้ทุกเมื่อ โดยติดต่อนายทะเบียนหลักทรัพย์ที่เบอร์ 02-298-0821-30 กด 1</li>
            </ul>
            <p class="consent-text-body">
              เมื่อท่านกดปุ่ม "ยอมรับ" ถือว่าท่านได้อ่าน เข้าใจ และยินยอมให้ดำเนินการตามข้อกำหนดข้างต้นแล้ว
            </p>
          </div>
          <div class="consent-actions">
            <a class="cta-nav" @click="goBackFromConsent">
              <span>← กลับหน้าหลัก</span>
            </a>
            <v-btn
              color="success"
              class="consent-accept-btn"
              :loading="overlay"
              @click="acceptConsent"
            >
              ยอมรับ
            </v-btn>
          </div>
        </div>
      </div>
    </div>

    <!-- Document Selection Screen (After Paotang Login) -->
    <div v-if="showDocumentSelection" class="document-selection">
      <div class="wrapper">
        <a
          class="cta"
          :style="{ fontSize: scale(25) + 'px' }"
          @click="goToDownload50"
        >
          <span style="margin-top: 10px">Download หนังสือรับรองภาษี ณ ที่จ่าย (50ทวิ)</span>
          <span>
            <svg
              :width="scale(66) + 'px'"
              :height="scale(43) + 'px'"
              viewBox="0 0 66 43"
              version="1.1"
            >
              <g
                id="arrow"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <path
                  class="one"
                  d="M40.1543933,3.89485454 L43.9763149,0.139296592 C44.1708311,-0.0518420739 44.4826329,-0.0518571125 44.6771675,0.139262789 L65.6916134,20.7848311 C66.0855801,21.1718824 66.0911863,21.8050225 65.704135,22.1989893 C65.7000188,22.2031791 65.6958657,22.2073326 65.6916762,22.2114492 L44.677098,42.8607841 C44.4825957,43.0519059 44.1708242,43.0519358 43.9762853,42.8608513 L40.1545186,39.1069479 C39.9575152,38.9134427 39.9546793,38.5968729 40.1481845,38.3998695 C40.1502893,38.3977268 40.1524132,38.395603 40.1545562,38.3934985 L56.9937789,21.8567812 C57.1908028,21.6632968 57.193672,21.3467273 57.0001876,21.1497035 C56.9980647,21.1475418 56.9959223,21.1453995 56.9937605,21.1432767 L40.1545208,4.60825197 C39.9574869,4.41477773 39.9546013,4.09820839 40.1480756,3.90117456 C40.1501626,3.89904911 40.1522686,3.89694235 40.1543933,3.89485454 Z"
                  fill="#FFFFFF"
                ></path>
                <path
                  class="two"
                  d="M20.1543933,3.89485454 L23.9763149,0.139296592 C24.1708311,-0.0518420739 24.4826329,-0.0518571125 24.6771675,0.139262789 L45.6916134,20.7848311 C46.0855801,21.1718824 46.0911863,21.8050225 45.704135,22.1989893 C45.7000188,22.2031791 45.6958657,22.2073326 45.6916762,22.2114492 L24.677098,42.8607841 C24.4825957,43.0519059 24.1708242,43.0519358 23.9762853,42.8608513 L20.1545186,39.1069479 C19.9575152,38.9134427 19.9546793,38.5968729 20.1481845,38.3998695 C20.1502893,38.3977268 20.1524132,38.395603 20.1545562,38.3934985 L36.9937789,21.8567812 C37.1908028,21.6632968 37.193672,21.3467273 37.0001876,21.1497035 C36.9980647,21.1475418 36.9959223,21.1453995 36.9937605,21.1432767 L20.1545208,4.60825197 C19.9574869,4.41477773 19.9546013,4.09820839 20.1480756,3.90117456 C20.1501626,3.89904911 20.1522686,3.89694235 20.1543933,3.89485454 Z"
                  fill="#FFFFFF"
                ></path>
                <path
                  class="three"
                  d="M0.154393339,3.89485454 L3.97631488,0.139296592 C4.17083111,-0.0518420739 4.48263286,-0.0518571125 4.67716753,0.139262789 L25.6916134,20.7848311 C26.0855801,21.1718824 26.0911863,21.8050225 25.704135,22.1989893 C25.7000188,22.2031791 25.6958657,22.2073326 25.6916762,22.2114492 L4.67709797,42.8607841 C4.48259567,43.0519059 4.17082418,43.0519358 3.97628526,42.8608513 L0.154518591,39.1069479 C-0.0424848215,38.9134427 -0.0453206733,38.5968729 0.148184538,38.3998695 C0.150289256,38.3977268 0.152413239,38.395603 0.154556228,38.3934985 L16.9937789,21.8567812 C17.1908028,21.6632968 17.193672,21.3467273 17.0001876,21.1497035 C16.9980647,21.1475418 16.9959223,21.1453995 16.9937605,21.1432767 L0.15452076,4.60825197 C-0.0425130651,4.41477773 -0.0453986756,4.09820839 0.148075568,3.90117456 C0.150162624,3.89904911 0.152268631,3.89694235 0.154393339,3.89485454 Z"
                  fill="#FFFFFF"
                ></path>
              </g>
            </svg>
          </span>
        </a>
      </div>

      <div class="wrapper">
        <a
          class="cta"
          :style="{ fontSize: scale(25) + 'px' }"
          @click="goToCertificate"
        >
          <span style="margin-top: 10px">Download หนังสือรับรองการเป็นผู้ถือกรรมสิทธิ์ในตราสารหนี้</span>
          <span>
            <svg
              :width="scale(66) + 'px'"
              :height="scale(43) + 'px'"
              viewBox="0 0 66 43"
              version="1.1"
            >
              <g
                id="arrow"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <path
                  class="one"
                  d="M40.1543933,3.89485454 L43.9763149,0.139296592 C44.1708311,-0.0518420739 44.4826329,-0.0518571125 44.6771675,0.139262789 L65.6916134,20.7848311 C66.0855801,21.1718824 66.0911863,21.8050225 65.704135,22.1989893 C65.7000188,22.2031791 65.6958657,22.2073326 65.6916762,22.2114492 L44.677098,42.8607841 C44.4825957,43.0519059 44.1708242,43.0519358 43.9762853,42.8608513 L40.1545186,39.1069479 C39.9575152,38.9134427 39.9546793,38.5968729 40.1481845,38.3998695 C40.1502893,38.3977268 40.1524132,38.395603 40.1545562,38.3934985 L56.9937789,21.8567812 C57.1908028,21.6632968 57.193672,21.3467273 57.0001876,21.1497035 C56.9980647,21.1475418 56.9959223,21.1453995 56.9937605,21.1432767 L40.1545208,4.60825197 C39.9574869,4.41477773 39.9546013,4.09820839 40.1480756,3.90117456 C40.1501626,3.89904911 40.1522686,3.89694235 40.1543933,3.89485454 Z"
                  fill="#FFFFFF"
                ></path>
                <path
                  class="two"
                  d="M20.1543933,3.89485454 L23.9763149,0.139296592 C24.1708311,-0.0518420739 24.4826329,-0.0518571125 24.6771675,0.139262789 L45.6916134,20.7848311 C46.0855801,21.1718824 46.0911863,21.8050225 45.704135,22.1989893 C45.7000188,22.2031791 45.6958657,22.2073326 45.6916762,22.2114492 L24.677098,42.8607841 C24.4825957,43.0519059 24.1708242,43.0519358 23.9762853,42.8608513 L20.1545186,39.1069479 C19.9575152,38.9134427 19.9546793,38.5968729 20.1481845,38.3998695 C20.1502893,38.3977268 20.1524132,38.395603 20.1545562,38.3934985 L36.9937789,21.8567812 C37.1908028,21.6632968 37.193672,21.3467273 37.0001876,21.1497035 C36.9980647,21.1475418 36.9959223,21.1453995 36.9937605,21.1432767 L20.1545208,4.60825197 C19.9574869,4.41477773 19.9546013,4.09820839 20.1480756,3.90117456 C20.1501626,3.89904911 20.1522686,3.89694235 20.1543933,3.89485454 Z"
                  fill="#FFFFFF"
                ></path>
                <path
                  class="three"
                  d="M0.154393339,3.89485454 L3.97631488,0.139296592 C4.17083111,-0.0518420739 4.48263286,-0.0518571125 4.67716753,0.139262789 L25.6916134,20.7848311 C26.0855801,21.1718824 26.0911863,21.8050225 25.704135,22.1989893 C25.7000188,22.2031791 25.6958657,22.2073326 25.6916762,22.2114492 L4.67709797,42.8607841 C4.48259567,43.0519059 4.17082418,43.0519358 3.97628526,42.8608513 L0.154518591,39.1069479 C-0.0424848215,38.9134427 -0.0453206733,38.5968729 0.148184538,38.3998695 C0.150289256,38.3977268 0.152413239,38.395603 0.154556228,38.3934985 L16.9937789,21.8567812 C17.1908028,21.6632968 17.193672,21.3467273 17.0001876,21.1497035 C16.9980647,21.1475418 16.9959223,21.1453995 16.9937605,21.1432767 L0.15452076,4.60825197 C-0.0425130651,4.41477773 -0.0453986756,4.09820839 0.148075568,3.90117456 C0.150162624,3.89904911 0.152268631,3.89694235 0.154393339,3.89485454 Z"
                  fill="#FFFFFF"
                ></path>
              </g>
            </svg>
          </span>
        </a>
      </div>
    </div>

    <div v-if="isPaotangLoading" class="paotang-fullscreen-loading">
      <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
    </div>

    <!-- Main Content (ID Input Screen) -->
    <v-container v-if="!showDocumentSelection && !showQRCode && !showConsent && !isPaotangLoading" class="main-content mt-2">
      <v-row justify="center" align="stretch">
        <!-- Left Section: Announcement -->
        <v-col cols="12" md="6" class="d-flex">
          <div class="announcement-card flex-grow-1">
            <div class="announcement-header">
              <span class="alert-badge">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="white">
                  <path d="M18 11v2h4v-2h-4zm-2 6.61c.96.71 2.21 1.65 3.2 2.39.4-.53.8-1.07 1.2-1.6-.99-.74-2.24-1.68-3.2-2.4-.4.54-.8 1.08-1.2 1.61zM20.4 5.6c-.4-.53-.8-1.07-1.2-1.6-.99.74-2.24 1.68-3.2 2.4.4.53.8 1.07 1.2 1.6.96-.72 2.21-1.65 3.2-2.4zM4 9c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h1v4h2v-4h1l5 3V6L8 9H4zm11.5 3c0-1.33-.58-2.53-1.5-3.35v6.69c.92-.81 1.5-2.01 1.5-3.34z"/>
                </svg>
              </span>
              <span class="announcement-title">ประกาศสำคัญ</span>
            </div>
            <p class="salutation">เรียน ท่านผู้ถือหุ้นกู้ทุกท่าน</p>
            <p class="announcement-body" style="text-indent: 2em">เพื่อยกระดับประสิทธิภาพในการยืนยันตัวตนและการให้บริการ ธนาคารขอแจ้งเปลี่ยนแปลงช่องทางการยืนยันตัวตนสำหรับการดาวน์โหลดหนังสือรับรองหักภาษี ณ ที่จ่าย (50 ทวิ) จากเดิมที่ใช้รหัส OTP ผ่านหมายเลขโทรศัพท์มือถือ เป็นการยืนยันตัวตนผ่านแอปพลิเคชัน <strong>เป๋าตัง</strong> แทน โดยมีรายละเอียดดังนี้</p>
            <ul class="announcement-list">
              <li>
                <strong>ระบบเดิม (OTP) จะปิดให้บริการ :</strong>
                <strong> 04/08/2569 เวลา 18.00 น.</strong>
              </li>
              <li>
                <strong>เริ่มใช้งานระบบใหม่ :</strong>
                <strong>ตั้งแต่วันที่ 05/08/2569 เป็นต้นไป</strong>
              </li>
              <li>
                <strong>สามารถศึกษาวิธีการใช้งานแบบทีละขั้นตอน พร้อมภาพประกอบได้ที่ :</strong>
                <strong><a href="#" class="announcement-link" @click.prevent="downloadManual">[ลิงก์]</a></strong>
              </li>
            </ul>
            <p class="announcement-body">ทั้งนี้ หากท่านพบปัญหาในการยืนยันตัวตนผ่านแอปพลิเคชัน <strong>เป๋าตัง</strong><br>สามารถติดต่อ Call Center ได้ที่เบอร์ <strong>02-111-1111</strong></p>
            <div class="announcement-footer">
              <p>จึงเรียนมาเพื่อโปรดทราบ</p>
              <p>ขอแสดงความนับถือ</p>
              <p><strong>ธนาคารกรุงไทย จำกัด (มหาชน)</strong></p>
              <p>ในฐานะนายทะเบียนหลักทรัพย์และตัวแทนชำระเงิน</p>
            </div>
          </div>
        </v-col>

        <!-- Right Section: Login + Download Forms -->
        <v-col cols="12" md="6" class="d-flex flex-column">
          <v-card class="content-card elevation-8 mb-4">
            <v-card-title class="card-title-section">
              <v-icon large color="primary" class="mr-2">mdi-card-account-details</v-icon>
              <span>เข้าสู่ระบบ</span>
            </v-card-title>
            
            <v-divider></v-divider>
            
            <v-card-text class="pa-4">
              <div class="instruction-text mb-2">
                <p class="text-subtitle-1 mb-1">1. Download 50ทวิ</p>
                <p class="text-subtitle-1 mb-1">2. Download หนังสือรับรองการเป็นผู้ถือกรรมสิทธิ์ในตราสารหนี้</p>
              </div>

              <v-divider class="my-2"></v-divider>

              <div class="input-section">
                <p class="input-label">โปรดระบุเลขที่บัตรประจำตัวประชาชน 13 หลัก :</p>
                <v-text-field
                  :key="fieldResetKey"
                  v-model="cifno"
                  v-mask="'#-####-#####-##-#'"
                  label="เลขที่บัตรประชาชน (Citizen ID)"
                  outlined
                  dense
                  class="mt-3"
                  color="primary"
                  prepend-inner-icon="mdi-account-card-details"
                  :rules="[rules.required, rules.idCard]"
                  placeholder="X-XXXX-XXXXX-XX-X"
                  :disabled="isVerified"
                ></v-text-field>

                <v-btn
                  v-if="!isVerified"
                  block
                  large
                  color="success"
                  class="mt-4 login-btn-simple"
                  @click="handleLogin"
                >
                  เข้าสู่ระบบ
                </v-btn>

                <div v-if="isVerified" class="mt-4">
                  <p class="paotang-btn-label" style="color: red;">กรุณายืนยันตัวตน</p>
                  <v-btn
                    block
                    x-large
                    color="info"
                    class="paotang-login-btn"
                    @click="handlePaotangLogin"
                  >
                    <img :src="paotangLogo" alt="Paotang" class="paotang-logo" />
                    แอปพลิเคชั่นเป๋าตัง
                  </v-btn>
                </div>
              </div>
            </v-card-text>
          </v-card>

          <v-card class="content-card elevation-8 flex-grow-1">
            <v-card-title class="card-title-section">
              <v-icon large color="success" class="mr-2">mdi-download</v-icon>
              <span>Download แบบฟอร์มหุ้นกู้</span>
            </v-card-title>
            
            <v-divider></v-divider>
            
            <v-card-text class="pa-4">
              <div class="wrapper">
                <a class="cta" :style="{ fontSize: scale(20) + 'px' }" @click="goToDownloadList">
                  <span style="margin-top: 10px">Download แบบฟอร์มหุ้นกู้</span>
                  <span>
                    <svg
                      :width="scale(66) + 'px'"
                      :height="scale(43) + 'px'"
                      viewBox="0 0 66 43"
                      version="1.1"
                    >
                      <g
                        id="arrow"
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <path
                          class="one"
                          d="M40.1543933,3.89485454 L43.9763149,0.139296592 C44.1708311,-0.0518420739 44.4826329,-0.0518571125 44.6771675,0.139262789 L65.6916134,20.7848311 C66.0855801,21.1718824 66.0911863,21.8050225 65.704135,22.1989893 C65.7000188,22.2031791 65.6958657,22.2073326 65.6916762,22.2114492 L44.677098,42.8607841 C44.4825957,43.0519059 44.1708242,43.0519358 43.9762853,42.8608513 L40.1545186,39.1069479 C39.9575152,38.9134427 39.9546793,38.5968729 40.1481845,38.3998695 C40.1502893,38.3977268 40.1524132,38.395603 40.1545562,38.3934985 L56.9937789,21.8567812 C57.1908028,21.6632968 57.193672,21.3467273 57.0001876,21.1497035 C56.9980647,21.1475418 56.9959223,21.1453995 56.9937605,21.1432767 L40.1545208,4.60825197 C39.9574869,4.41477773 39.9546013,4.09820839 40.1480756,3.90117456 C40.1501626,3.89904911 40.1522686,3.89694235 40.1543933,3.89485454 Z"
                          fill="#FFFFFF"
                        ></path>
                        <path
                          class="two"
                          d="M20.1543933,3.89485454 L23.9763149,0.139296592 C24.1708311,-0.0518420739 24.4826329,-0.0518571125 24.6771675,0.139262789 L45.6916134,20.7848311 C46.0855801,21.1718824 46.0911863,21.8050225 45.704135,22.1989893 C45.7000188,22.2031791 45.6958657,22.2073326 45.6916762,22.2114492 L24.677098,42.8607841 C24.4825957,43.0519059 24.1708242,43.0519358 23.9762853,42.8608513 L20.1545186,39.1069479 C19.9575152,38.9134427 19.9546793,38.5968729 20.1481845,38.3998695 C20.1502893,38.3977268 20.1524132,38.395603 20.1545562,38.3934985 L36.9937789,21.8567812 C37.1908028,21.6632968 37.193672,21.3467273 37.0001876,21.1497035 C36.9980647,21.1475418 36.9959223,21.1453995 36.9937605,21.1432767 L20.1545208,4.60825197 C19.9574869,4.41477773 19.9546013,4.09820839 20.1480756,3.90117456 C20.1501626,3.89904911 20.1522686,3.89694235 20.1543933,3.89485454 Z"
                          fill="#FFFFFF"
                        ></path>
                        <path
                          class="three"
                          d="M0.154393339,3.89485454 L3.97631488,0.139296592 C4.17083111,-0.0518420739 4.48263286,-0.0518571125 4.67716753,0.139262789 L25.6916134,20.7848311 C26.0855801,21.1718824 26.0911863,21.8050225 25.704135,22.1989893 C25.7000188,22.2031791 25.6958657,22.2073326 25.6916762,22.2114492 L4.67709797,42.8607841 C4.48259567,43.0519059 4.17082418,43.0519358 3.97628526,42.8608513 L0.154518591,39.1069479 C-0.0424848215,38.9134427 -0.0453206733,38.5968729 0.148184538,38.3998695 C0.150289256,38.3977268 0.152413239,38.395603 0.154556228,38.3934985 L16.9937789,21.8567812 C17.1908028,21.6632968 17.193672,21.3467273 17.0001876,21.1497035 C16.9980647,21.1475418 16.9959223,21.1453995 16.9937605,21.1432767 L0.15452076,4.60825197 C-0.0425130651,4.41477773 -0.0453986756,4.09820839 0.148075568,3.90117456 C0.150162624,3.89904911 0.152268631,3.89694235 0.154393339,3.89485454 Z"
                          fill="#FFFFFF"
                        ></path>
                      </g>
                    </svg>
                  </span>
                </a>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Dialog -->
    <v-dialog v-model="dialog" width="500">
      <v-card outlined>
        <v-card-title></v-card-title>
        <v-card-text min-height="300px" class="pb-0">
          <v-alert dense outlined type="error" class="alerttext">
            <div :style="{ fontSize: scale(16) + 'px' }">
              {{ dialogText }}
            </div>
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="dialog = false">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import PaotangLogo from '@/assets/img/Paotang_Logo.png';

export default {
  name: "HomeViewPaoTangVer",
  beforeRouteEnter(_to, _from, next) {
    next(vm => {
      if (_to.query.paotang_auth !== 'success') {
        vm.resetToHome();
      }
    });
  },
  data() {
    return {
      paotangLogo: PaotangLogo,
      cifno: "",
      fieldResetKey: 0,
      dialog: false,
      dialogText: "",
      overlay: false,
      isPaotangLoading: false,
      reftype: "1",
      responseRefno: [],
      ClientIP: "",
      isVerified: false,
      showDocumentSelection: false,
      showQRCode: false,
      showConsent: false,
      manualFileName: "คู่มือการใช้งาน_บริการนายทะเบียนหลักทรัพย์.pdf",
      rules: {
        required: value => !!value || 'กรุณากรอกเลขที่บัตรประชาชน',
        idCard: value => {
          const cleaned = value.replace(/-/g, '');
          return cleaned.length === 13 || 'เลขบัตรประชาชนต้องมี 13 หลัก';
        }
      }
    };
  },
  computed: {
    ...mapGetters('Block', ['isBlocked', 'remainingTime']),
  },
  created() {
    if (this.$route.query.paotang_auth === 'success') {
      this.isPaotangLoading = true;
    }
  },
  async mounted() {
    if (this.$route.query.paotang_auth === 'success') {
      sessionStorage.removeItem('paotang_refno_data');

      const userData = this.$store.getters['Auth/getUserData'];
      const cifno = (userData && userData.cifno)
        || sessionStorage.getItem('paotang_auth_cifno')
        || '';
      sessionStorage.removeItem('paotang_auth_cifno');
      console.log('[PaotangCallback] mounted cifno:', cifno);

      if (!cifno) {
        this.dialogText = 'ไม่สามารถดึงข้อมูลผู้ใช้ได้ กรุณาลองใหม่อีกครั้ง';
        this.dialog = true;
        this.isPaotangLoading = false;
        return;
      }

      this.cifno = cifno;

      try {
        const resp = await this.$store.dispatch('Auth/funcPostRefnoInform', {
          Reqtype: this.reftype,
          Refno: cifno,
          UserIP: this.ClientIP,
        });
        this.responseRefno = resp;
        this.showDocumentSelection = true;
      } catch (err) {
        console.error('[PaotangCallback] PostRefnoInform error:', err);
        this.dialogText = 'ไม่สามารถดึงข้อมูลได้ กรุณาลองใหม่อีกครั้ง';
        this.dialog = true;
      } finally {
        this.isPaotangLoading = false;
      }
    }
  },
  methods: {
    ...mapActions('Block', ['handleAttempt']),

    downloadManual() {
      const postDownload = {
        Filename: this.manualFileName,
      };
      this.$store
        .dispatch("MDownload50/funcPostDownloadForm", postDownload)
        .then((resp) => {
          if (resp != null && resp.Formload) {
            var byteCharacters = atob(resp.Formload);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            let blob = new Blob([byteArray], { type: "application/pdf" }),
              url = window.URL.createObjectURL(blob);

            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = url;
            a.download = this.manualFileName;
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
          }
        })
        .catch(() => {
          this.isShowError = true;
        });
    },

    scale(num) {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return (num * 60) / 100;
        case "sm":
          return (num * 70) / 100;
        case "md":
          return (num * 90) / 100;
        case "lg":
          return (num * 95) / 100;
        case "xl":
          return num;
        default:
          return num;
      }
    },

    handleLogin() {
      this.overlay = true;

      if(this.isBlocked) {
        this.dialogText = `ขออภัย! คุณร้องขอบริการเกินจำนวนครั้งที่กำหนด กรุณาลองใหม่ภายหลัง หรือติดต่อนายทะเบียนหลักทรัพย์ที่เบอร์ 02-298-0821-30 กด 1`;
        this.dialog = true;
        this.overlay = false;
        return;
      }

      var cif = this.cifno.replace(/-/g, "");
      if (cif.length < 13) {
        this.dialogText = "กรุณากรอกเลขที่บัตรประชาชนให้ครบถ้วน";
        this.dialog = true;
        this.overlay = false;
        return;
      }

      // Call API to verify citizen ID
      const postData = {
        Reqtype: this.reftype,
        Refno: this.cifno.replaceAll("-", ""),
        UserIP: this.ClientIP,
      };

      this.$store
        .dispatch("Auth/funcPostRefnoInform", postData)
        .then((resp) => {
          if (resp != null) {
            this.responseRefno = resp;
            
            if (this.responseRefno.FileCount <= "0") {
              this.dialogText =
                "ไม่พบข้อมูล หนังสือรับรองการหักภาษี ณ ที่จ่าย ฉบับทดแทน กรุณาติดต่อนายทะเบียนหลักทรัพย์ที่เบอร์ 02-298-0821-30 กด 1";
              this.dialog = true;
              this.overlay = false;
              return;
            }

            if (this.responseRefno.refno == "") {
              this.dialogText =
                "ไม่พบเลขที่บัตรประชาชนนี้ในระบบ กรุณาติดต่อนายทะเบียนหลักทรัพย์ที่เบอร์ 02-298-0821-30 กด 1";
              this.dialog = true;
              this.overlay = false;
              return;
            }

           /* if (
              this.responseRefno.mobile_otp == "" ||
              this.responseRefno.mobile_otp.length != 10
            ) {
              this.dialogText =
                "ไม่พบหมายเลขโทรศัพท์ที่ทำการเชื่อมโยงกับเลขที่บัตรประชาชนนี้ในระบบ กรุณาติดต่อนายทะเบียนหลักทรัพย์ที่เบอร์ 02-298-0821-30 กด 1";
              this.dialog = true;
              this.overlay = false;
              return;
            }*/

            this.overlay = false;
            this.isVerified = true;
          }
        })
        .catch((err) => {
          console.error("error", err);
          if (err.response && err.response.status == 429) {
            this.dialogText =
              `ขออภัย! คุณร้องขอบริการเกินจำนวนครั้งที่กำหนด กรุณาลองใหม่ภายหลัง`;
          } else {
            this.dialogText = "ขออภัย! การเชื่อมต่อมีปัญหา";
          }
          this.dialog = true;
          this.overlay = false;
        });
    },

    checkIDCard(id) {
      if (id.length != 13) return false;
      
      var sum = 0;
      for (var i = 0; i < 12; i++) {
        sum += parseFloat(id.charAt(i)) * (13 - i);
      }
      
      var mod = sum % 11;
      var check = (11 - mod) % 10;
      
      if (check == parseFloat(id.charAt(12))) {
        return true;
      }
      return false;
    },

    goToDownloadList() {
      this.$router.push('/DownloadListView');
    },

    async handlePaotangLogin() {
      try {
        sessionStorage.setItem('paotang_refno_data', JSON.stringify(this.responseRefno));
        // cifno is bound server-side into the signed OAuth state (not sessionStorage) so
        // it survives the tab being backgrounded/discarded during the QR-scan hand-off.
        const resp = await this.$store.dispatch('Auth/funcPaotangAuthInit', this.cifno.replace(/-/g, ''));
        console.log('[PaotangOAuth] redirecting to:', resp.auth_url);
        window.location.href = resp.auth_url;
      } catch (err) {
        console.error('[PaotangOAuth] login error:', err);
        sessionStorage.removeItem('paotang_refno_data');
        this.dialogText = 'ขออภัย! ไม่สามารถเชื่อมต่อกับ Paotang ได้ กรุณาลองใหม่อีกครั้ง';
        this.dialog = true;
      }
    },

    handleQRCodeClick() {
      this.showQRCode = false;
      this.showDocumentSelection = true;
    },

    resetToHome() {
      this.isVerified = false;
      this.showQRCode = false;
      this.showDocumentSelection = false;
      this.showConsent = false;
      this.cifno = "";
      this.fieldResetKey++;
      this.$store.commit('Auth/SET_USER_DATA', null);
    },

    goBackFromConsent() {
      this.showConsent = false;
      this.resetToHome();
    },

    async acceptConsent() {
      this.overlay = true;
      const refno = this.cifno.replace(/-/g, "");
      try {
        await this.$store.dispatch("Auth/funcPostUpdateAuthConfirm", { Refno: refno });
        this.showConsent = false;
        this.showQRCode = true;
      } catch (err) {
        this.dialogText = "ขออภัย! ไม่สามารถบันทึกความยินยอมได้ กรุณาลองใหม่อีกครั้ง";
        this.dialog = true;
      } finally {
        this.overlay = false;
      }
    },

    goBackFromDocs() {
      this.showDocumentSelection = false;
      this.showQRCode = true;
    },

    goToDownload50() {
      this.$store.commit('Auth/SET_USER_DATA', {
        refno: this.cifno.replace(/-/g, ""),
        mobile_otp: this.responseRefno.mobile_otp,
        prefixname: this.responseRefno.prefixname,
        firstname: this.responseRefno.firstname,
        lastname: this.responseRefno.lastname,
        FileCount: this.responseRefno.FileCount,
        fromPaotang: true
      });
      this.$router.replace('/download50');
    },

    goToCertificate() {
      this.$store.commit('Auth/SET_USER_DATA', {
        refno: this.cifno.replace(/-/g, ""),
        mobile_otp: this.responseRefno.mobile_otp,
        prefixname: this.responseRefno.prefixname,
        firstname: this.responseRefno.firstname,
        lastname: this.responseRefno.lastname,
        FileCount: this.responseRefno.FileCount,
        fromPaotang: true
      });
      this.$router.replace('/certificate');
    }
  }
};
</script>

<style scoped>
.paotang-container {
  background-image: url('../assets/img/bgtest.jpg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  padding: clamp(8px, 1.2vh, 12px) clamp(12px, 1.5vw, 20px);
  position: relative;
}

.paotang-container::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -10%;
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(0, 166, 230, 0.08) 0%, transparent 70%);
  border-radius: 50%;
  pointer-events: none;
}

.paotang-container::after {
  content: '';
  position: absolute;
  bottom: -30%;
  left: -10%;
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(42, 82, 152, 0.06) 0%, transparent 70%);
  border-radius: 50%;
  pointer-events: none;
}

.document-selection {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: clamp(20px, 4vh, 60px) clamp(8px, 2vw, 20px);
  position: relative;
  z-index: 1;
}

.document-selection .wrapper {
  margin-top: clamp(12px, 2vh, 30px);
  width: 100%;
  max-width: 1000px;
}

.header-card {
  background: linear-gradient(135deg, rgb(0, 166, 230, 1) 20%, rgba(42, 82, 152, 0.95) 80%);
  border-radius: 20px !important;
  margin-bottom: 30px;
  box-shadow: 0 10px 40px rgba(0, 166, 230, 0.25);
  overflow: hidden;
  position: relative;
}

.header-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.header-card:hover::before {
  opacity: 1;
}

.header-title {
  color: white;
  padding: 32px 28px;
  display: flex;
  align-items: center;
}

.title-text h2 {
  font-family: 'Ktcfast', sans-serif;
  font-size: 28px;
  margin: 0;
  font-weight: 700;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}

.subtitle-text {
  font-size: 16px;
  margin: 4px 0 0 0;
  opacity: 0.95;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
}

.main-content {
  max-width: 1600px;
  position: relative;
  z-index: 1;
}

.content-card {
  background: white;
  border-radius: 20px !important;
  transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275), box-shadow 0.4s ease;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 166, 230, 0.1);
  overflow: hidden;
  position: relative;
}

.content-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #00a6e6 0%, #2a5298 100%);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.4s ease;
}

.content-card:hover::before {
  transform: scaleX(1);
}

.content-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 60px rgba(0, 166, 230, 0.2) !important;
}

.card-title-section {
  background: linear-gradient(135deg, rgba(0, 166, 230, 0.05) 0%, rgba(42, 82, 152, 0.05) 100%);
  font-family: 'Ktcfast', sans-serif;
  font-size: clamp(15px, 1.5vw, 20px);
  font-weight: 700;
  color: #1e3c72;
  padding: clamp(8px, 1vh, 12px) clamp(12px, 1.5vw, 20px);
  border-bottom: 2px solid rgba(0, 166, 230, 0.1);
}

.instruction-text {
  font-family: 'Ktcfast', sans-serif;
  font-size: clamp(13px, 1.3vw, 16px);
  color: #2c3e50;
  background: linear-gradient(135deg, rgba(0, 166, 230, 0.03) 0%, transparent 100%);
  padding: clamp(6px, 0.8vh, 10px) clamp(10px, 1.2vw, 16px);
  border-radius: 12px;
  border-left: 4px solid #00a6e6;
}

.instruction-text p {
  line-height: 1.5;
  margin-bottom: 2px;
  font-weight: 500;
  position: relative;
  padding-left: 10px;
}

.instruction-text p::before {
  content: '•';
  position: absolute;
  left: 0;
  color: #00a6e6;
  font-size: 20px;
  font-weight: bold;
}

.input-section {
  margin-top: clamp(8px, 1vh, 12px);
  padding: clamp(8px, 1vh, 12px) clamp(10px, 1.2vw, 16px);
  background: rgba(248, 250, 252, 0.5);
  border-radius: 12px;
}

.input-label {
  font-family: 'Ktcfast', sans-serif;
  font-size: clamp(13px, 1.3vw, 17px);
  color: #2c3e50;
  font-weight: 600;
  margin-bottom: 8px;
}

.login-btn-simple {
  font-family: 'Ktcfast', sans-serif;
  font-size: clamp(14px, 1.4vw, 18px) !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.5px;
  padding: clamp(10px, 1.2vh, 14px) !important;
  height: auto !important;
  border-radius: 12px !important;
  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);
  transition: all 0.3s ease;
}

.login-btn-simple:hover {
  box-shadow: 0 6px 25px rgba(76, 175, 80, 0.4);
  transform: translateY(-2px);
}

.paotang-btn-label {
  font-family: 'Ktcfast', sans-serif;
  font-size: clamp(11px, 1.1vw, 13px);
  color: #7f8c8d;
  text-align: center;
  margin-bottom: 6px;
}

.paotang-logo {
  height: clamp(33px, 2.5vh, 32px);
  width: auto;
  margin-right: 12px;
  transition: all 0.3s ease;
}

.paotang-login-btn {
  font-family: 'Ktcfast', sans-serif;
  font-size: clamp(15px, 1.5vw, 20px) !important;
  font-weight: 700;
  text-transform: none;
  letter-spacing: 0.5px;
  padding: clamp(12px, 1.4vh, 18px) !important;
  height: auto !important;
  background: linear-gradient(135deg, #00a6e6 0%, #0d8ac7 100%) !important;
  color: white !important;
  border-radius: 12px !important;
  box-shadow: 0 6px 25px rgba(0, 166, 230, 0.35);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.paotang-login-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

.paotang-login-btn:hover::before {
  width: 300px;
  height: 300px;
}

.paotang-login-btn:hover {
  box-shadow: 0 8px 35px rgba(0, 166, 230, 0.45);
  transform: translateY(-3px);
}

.alerttext {
  margin-top: 5px;
  font-family: "Ktcfast";
  font-size: 20px;
}

/* Announcement Panel */
.announcement-card {
  background: #ffffff;
  border-left: 6px solid #00a6e6;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
  padding: clamp(18px, 2.5vh, 34px) clamp(20px, 3vw, 38px);
  width: 100%;
  font-family: "Sarabun", "Noto Sans Thai", Arial, sans-serif;
  font-size: 17px;
  line-height: 1.8;
  color: #1a1a1a;
  margin-bottom: 16px;
}

.announcement-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e0e0e0;
}

.alert-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #e53935;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  animation: badge-flash 2s ease-in-out infinite;
  flex-shrink: 0;
  box-shadow: 0 0 8px rgba(229, 57, 53, 0.6);
}

@keyframes badge-flash {
  0%, 100% { opacity: 1; }
  50%       { opacity: 0.6; }
}

.announcement-title {
  font-size: 22px !important;
  font-family: "Sarabun", "Noto Sans Thai", Arial, sans-serif !important;
  font-weight: 700;
  color: #00a6e6;
  letter-spacing: 0.5px;
}

.salutation {
  font-weight: 700;
  font-size: 18px !important;
  font-family: "Sarabun", "Noto Sans Thai", Arial, sans-serif !important;
  margin-bottom: 10px;
}

.announcement-body {
  font-size: 17px !important;
  font-family: "Sarabun", "Noto Sans Thai", Arial, sans-serif !important;
  margin-bottom: 12px;
  text-align: left;
  word-break: break-word;
}

.announcement-list {
  list-style: none;
  padding: 0;
  margin: 0 0 14px 0;
}

.announcement-list li {
  font-size: 17px !important;
  font-family: "Sarabun", "Noto Sans Thai", Arial, sans-serif !important;
  padding: 6px 12px;
  border-left: 3px solid #fbc638;
  margin-bottom: 8px;
  background: #fffbf0;
  border-radius: 0 4px 4px 0;
}

.announcement-link {
  color: #00a6e6;
  text-decoration: underline;
}

.announcement-footer {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #e0e0e0;
  font-size: 17px !important;
  font-family: "Sarabun", "Noto Sans Thai", Arial, sans-serif !important;
}

.announcement-footer p {
  margin: 2px 0;
  font-size: 17px !important;
  font-family: "Sarabun", "Noto Sans Thai", Arial, sans-serif !important;
  line-height: 1.8 !important;
}

/* QR mode — collapse container so v-row doesn't overflow */
.qr-mode {
  padding: 0 !important;
  height: 0 !important;
  overflow: visible !important;
}

.qr-mode::before,
.qr-mode::after {
  display: none;
}

/* QR Code Screen — fixed overlay ระหว่าง header กับ footer */
.qr-screen {
  position: fixed;
  top: 63px;
  left: 0;
  right: 0;
  bottom: 68px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8vh 8vw;
  z-index: 4;
  overflow: hidden;
}

.qr-card {
  background: white;
  border-radius: 28px;
  width: 75%;
  max-width: 900px;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 12px 48px rgba(0, 166, 230, 0.15), 0 4px 12px rgba(0,0,0,0.08);
  border: 2px solid rgba(0, 166, 230, 0.2);
  position: relative;
  margin: 0 auto;
}

.qr-card::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 6px;
  background: linear-gradient(90deg, #00a6e6 0%, #2a5298 100%);
  border-radius: 28px 28px 0 0;
}

.qr-card-header {
  background: linear-gradient(135deg, rgba(0, 166, 230, 0.05) 0%, rgba(42, 82, 152, 0.05) 100%);
  font-family: 'Ktcfast', sans-serif;
  font-size: clamp(16px, 1.8vw, 22px);
  font-weight: 700;
  color: #1e3c72;
  padding: clamp(16px, 2vh, 24px) clamp(20px, 3vw, 32px);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  position: relative;
  z-index: 2;
}

.qr-card-divider {
  height: 2px;
  background: rgba(0, 166, 230, 0.1);
  width: 100%;
}

.qr-card-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: clamp(24px, 4vh, 48px) clamp(20px, 3.5vw, 48px);
  gap: clamp(16px, 3vh, 32px);
  cursor: pointer;
  background: linear-gradient(160deg, #ffffff 0%, #f8fbff 100%);
}



.qr-box {
  position: relative;
  width: clamp(160px, 22vh, 240px);
  height: clamp(160px, 22vh, 240px);
  padding: clamp(12px, 1.5vh, 16px);
  background: white;
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 166, 230, 0.2), 0 2px 8px rgba(0,0,0,0.1);
  border: 3px solid rgba(0, 166, 230, 0.1);
  transition: all 0.3s ease;
}

.qr-box:hover {
  transform: scale(1.05);
  box-shadow: 0 12px 40px rgba(0, 166, 230, 0.25), 0 4px 12px rgba(0,0,0,0.12);
  border-color: rgba(0, 166, 230, 0.3);
}

.qr-corner {
  position: absolute;
  width: 32px;
  height: 32px;
  transition: all 0.3s ease;
}

.qr-box:hover .qr-corner {
  width: 36px;
  height: 36px;
}

.qr-corner--tl {
  top: 6px;
  left: 6px;
  border-top: 4px solid #00a6e6;
  border-left: 4px solid #00a6e6;
  border-radius: 6px 0 0 0;
}

.qr-corner--tr {
  top: 6px;
  right: 6px;
  border-top: 4px solid #00a6e6;
  border-right: 4px solid #00a6e6;
  border-radius: 0 6px 0 0;
}

.qr-corner--bl {
  bottom: 6px;
  left: 6px;
  border-bottom: 4px solid #00a6e6;
  border-left: 4px solid #00a6e6;
  border-radius: 0 0 0 6px;
}

.qr-corner--br {
  bottom: 6px;
  right: 6px;
  border-bottom: 4px solid #00a6e6;
  border-right: 4px solid #00a6e6;
  border-radius: 0 0 6px 0;
}

.qr-svg {
  width: 100%;
  height: 100%;
}

.qr-instruction {
  text-align: center;
  width: 100%;
  max-width: 400px;
}

.qr-instruction-text {
  font-family: 'Ktcfast', sans-serif;
  font-size: clamp(16px, 1.8vw, 22px);
  font-weight: 700;
  color: #1e3c72;
  margin-bottom: 6px;
}

.qr-instruction-subtext {
  font-family: 'Ktcfast', sans-serif;
  font-size: clamp(13px, 1.4vw, 17px);
  color: #5a6575;
  margin: 0;
  font-weight: 500;
}

.qr-text-area {
  width: 100%;
  text-align: center;
  margin-top: auto;
}

/* Navigation back buttons */
.nav-row {
  display: flex;
  justify-content: center;
  gap: clamp(10px, 2vw, 20px);
  flex-wrap: wrap;
}

.doc-nav-row {
  display: flex;
  justify-content: center;
  gap: clamp(10px, 2vw, 20px);
  flex-wrap: wrap;
  margin-bottom: clamp(14px, 2.5vh, 24px);
  width: 100%;
}

.cta-nav {
  display: inline-flex;
  align-items: center;
  padding: clamp(6px, 0.9vh, 10px) clamp(16px, 2.2vw, 28px);
  text-decoration: none;
  font-family: "Ktcfast";
  font-size: clamp(12px, 1.1vw, 15px);
  color: #5a6575;
  background: rgba(255, 255, 255, 0.92);
  border: 2px solid rgba(90, 101, 117, 0.25);
  transition: all 0.45s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: 4px 4px 0 rgba(0, 0, 0, 0.10);
  transform: skewX(-15deg);
  cursor: pointer;
  border-radius: 4px;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.cta-nav span {
  transform: skewX(15deg);
  display: block;
}

.cta-nav:hover {
  box-shadow: 6px 6px 0 #fbc638;
  color: #2c3e50;
}

.cta-nav--home {
  color: #00a6e6;
  border-color: rgba(0, 166, 230, 0.3);
  background: rgba(240, 248, 255, 0.95);
}

.cta-nav--home:hover {
  color: #0d8ac7;
}

/* Button Style from HomeView.vue */
.wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.cta {
  display: flex;
  align-items: center;
  padding: clamp(10px, 1.5vh, 16px) clamp(20px, 4vw, 50px);
  text-decoration: none;
  font-family: "Ktcfast";
  font-size: clamp(14px, 1.8vw, 22px);
  color: white;
  background: linear-gradient(135deg, rgb(0, 166, 230, 1) 0%, rgb(13, 138, 199) 100%);
  transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: 8px 8px 0 rgba(0, 0, 0, 0.9), 0 6px 20px rgba(0, 166, 230, 0.3);
  transform: skewX(-15deg);
  cursor: pointer;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  font-weight: 600;
  letter-spacing: 0.5px;
  max-width: 100%;
  box-sizing: border-box;
}

.cta::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.6s;
}

.cta:hover::before {
  left: 100%;
}

.cta:focus {
  outline: none;
  box-shadow: 8px 8px 0 rgba(0, 0, 0, 0.9), 0 8px 30px rgba(0, 166, 230, 0.5);
}

.cta:hover {
  transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: 12px 12px 0 #fbc638, 0 10px 35px rgba(251, 198, 56, 0.4);
  transform: skewX(-15deg) translateY(-3px);
}

.cta span:nth-child(2) {
  transition: all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  margin-right: 0px;
}

.cta:hover span:nth-child(2) {
  transition: all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  margin-right: 50px;
}

.cta span {
  transform: skewX(15deg);
}

.cta span:nth-child(2) {
  width: 20px;
  margin-left: 35px;
  position: relative;
  top: 12%;
}

/* SVG Styles */
path.one {
  transition: all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  transform: translateX(-60%);
}

path.two {
  transition: all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  transform: translateX(-30%);
}

path.three {
  transition: all 0.3s ease;
}

.cta:hover path.three {
  animation: color_anim 1s infinite 0.2s;
}

.cta:hover path.one {
  transform: translateX(0%);
  animation: color_anim 1s infinite 0.6s;
}

.cta:hover path.two {
  transform: translateX(0%);
  animation: color_anim 1s infinite 0.4s;
}

/* SVG animations */
@keyframes color_anim {
  0% {
    fill: white;
  }
  50% {
    fill: #fbc638;
  }
  100% {
    fill: white;
  }
}

.paotang-card {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.95) 0%, rgba(118, 75, 162, 0.95) 100%) !important;
  border-radius: 24px !important;
  position: relative;
  overflow: hidden;
  box-shadow: 0 15px 50px rgba(102, 126, 234, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.paotang-card::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255,255,255,0.15) 0%, transparent 70%);
  animation: pulse 15s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1) rotate(0deg);
    opacity: 1;
  }
  50% {
    transform: scale(1.1) rotate(180deg);
    opacity: 0.8;
  }
}

.paotang-content {
  position: relative;
  z-index: 1;
}

.paotang-btn {
  font-family: 'Ktcfast', sans-serif;
  font-size: 20px !important;
  font-weight: 700;
  text-transform: none;
  border-radius: 50px !important;
  padding: 32px 48px !important;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: 0 8px 30px rgba(255, 255, 255, 0.3);
}

.paotang-btn:hover {
  transform: scale(1.08);
  box-shadow: 0 15px 45px rgba(255, 255, 255, 0.4) !important;
}

/* Responsive */
@media (max-width: 960px) {
  .content-card {
    margin-bottom: 12px;
  }

  .content-card:hover {
    transform: none;
  }

  .main-content {
    padding: 0 4px !important;
  }
}

@media (max-width: 600px) {
  .paotang-container {
    padding: 6px 8px;
  }

  .card-title-section {
    font-size: 15px !important;
    padding: 8px 12px !important;
  }

  .instruction-text {
    font-size: 13px !important;
    padding: 8px 10px !important;
  }

  .input-label {
    font-size: 13px !important;
    margin-bottom: 4px;
  }

  .input-section {
    padding: 8px 10px !important;
    margin-top: 6px !important;
  }

  .login-btn-simple {
    font-size: 14px !important;
    padding: 10px !important;
  }

  .paotang-logo {
    height: 20px;
    margin-right: 8px;
  }

  .paotang-login-btn {
    font-size: 14px !important;
    padding: 10px !important;
  }

  .document-selection {
    padding: 16px 8px;
  }

  .document-selection .wrapper {
    margin-top: 8px;
  }

  .cta span:nth-child(2) {
    margin-left: 16px;
  }

  .cta:hover span:nth-child(2) {
    margin-right: 20px;
  }

  .qr-card {
    border-radius: 16px;
    width: 90%;
  }

  .qr-card-header {
    font-size: 15px;
    padding: 12px 16px;
  }

  .qr-card-content {
    padding: 20px 12px 16px;
    gap: 12px;
  }

  .qr-box {
    width: clamp(140px, 45vw, 180px);
    height: clamp(140px, 45vw, 180px);
  }

  .qr-corner {
    width: 24px;
    height: 24px;
  }

  .content-card:hover {
    transform: none;
  }
}

@media (max-width: 400px) {
  .card-title-section {
    font-size: 13px !important;
  }

  .cta {
    padding: 8px 14px;
  }
}

/* Text Field Custom Styles */
::v-deep .v-text-field--outlined fieldset {
  border-color: rgba(0, 166, 230, 0.3);
  border-width: 2px;
  transition: all 0.3s ease;
}

::v-deep .v-text-field--outlined:hover fieldset {
  border-color: rgba(0, 166, 230, 0.5);
}

::v-deep .v-text-field--outlined.v-input--is-focused fieldset {
  border-color: #00a6e6;
  box-shadow: 0 0 0 3px rgba(0, 166, 230, 0.1);
}

::v-deep .v-input__icon--prepend-inner .v-icon {
  color: #00a6e6 !important;
}

/* Dialog Styles */
::v-deep .v-dialog {
  border-radius: 16px !important;
  overflow: hidden;
}

::v-deep .v-card {
  border-radius: 16px !important;
}

::v-deep .v-card__title {
  background: linear-gradient(135deg, rgba(0, 166, 230, 0.05) 0%, rgba(42, 82, 152, 0.05) 100%);
  border-bottom: 2px solid rgba(0, 166, 230, 0.1);
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 12px;
}

::-webkit-scrollbar-track {
  background: linear-gradient(135deg, #f5f7fa 0%, #e8eef5 100%);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #00a6e6 0%, #2a5298 100%);
  border-radius: 10px;
  border: 2px solid #f5f7fa;
  transition: all 0.3s ease;
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #2a5298 0%, #00a6e6 100%);
  border-color: #e8eef5;
}

/* Loading animation enhancement */
::v-deep .v-overlay {
  backdrop-filter: blur(2px);
  background: rgba(255, 255, 255, 0.3) !important;
}

.paotang-fullscreen-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

::v-deep .v-progress-circular {
  filter: drop-shadow(0 6px 12px rgba(0, 166, 230, 0.5));
}

/* Divider enhancement */
::v-deep .v-divider {
  border-color: rgba(0, 166, 230, 0.15) !important;
  border-width: 1.5px !important;
}

/* Consent Screen */
.consent-screen {
  position: fixed;
  top: 63px;
  left: 0;
  right: 0;
  bottom: 68px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4vh 6vw;
  z-index: 4;
  overflow: hidden;
}

.consent-card {
  background: white;
  border-radius: 28px;
  width: 80%;
  max-width: 860px;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 12px 48px rgba(0, 166, 230, 0.15), 0 4px 12px rgba(0,0,0,0.08);
  border: 2px solid rgba(0, 166, 230, 0.2);
  position: relative;
}

.consent-card::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 6px;
  background: linear-gradient(90deg, #00a6e6 0%, #2a5298 100%);
  border-radius: 28px 28px 0 0;
}

.consent-card-header {
  background: linear-gradient(135deg, rgba(0, 166, 230, 0.05) 0%, rgba(42, 82, 152, 0.05) 100%);
  font-family: 'Ktcfast', sans-serif;
  font-size: clamp(16px, 1.8vw, 22px);
  font-weight: 700;
  color: #1e3c72;
  padding: clamp(16px, 2vh, 24px) clamp(20px, 3vw, 32px);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 2;
}

.consent-card-divider {
  height: 2px;
  background: rgba(0, 166, 230, 0.1);
  width: 100%;
}

.consent-card-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: clamp(20px, 3vh, 36px) clamp(24px, 3.5vw, 48px);
  gap: clamp(16px, 2.5vh, 28px);
  background: linear-gradient(160deg, #ffffff 0%, #f8fbff 100%);
  overflow: hidden;
}

.consent-text-area {
  flex: 1;
  overflow-y: auto;
  padding-right: 8px;
}

.consent-text-title {
  font-family: 'Ktcfast', sans-serif;
  font-size: clamp(14px, 1.5vw, 18px);
  font-weight: 700;
  color: #1e3c72;
  margin-bottom: clamp(8px, 1.2vh, 14px);
}

.consent-text-body {
  font-family: 'Ktcfast', sans-serif;
  font-size: clamp(13px, 1.3vw, 16px);
  color: #2c3e50;
  line-height: 1.7;
  margin-bottom: clamp(8px, 1.2vh, 14px);
}

.consent-list {
  font-family: 'Ktcfast', sans-serif;
  font-size: clamp(13px, 1.3vw, 16px);
  color: #2c3e50;
  line-height: 1.8;
  padding-left: 20px;
  margin-bottom: clamp(8px, 1.2vh, 14px);
}

.consent-list li {
  margin-bottom: 6px;
}

.consent-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: clamp(12px, 2.5vw, 32px);
  flex-wrap: wrap;
  padding-top: clamp(8px, 1.5vh, 16px);
  border-top: 2px solid rgba(0, 166, 230, 0.1);
}

.consent-accept-btn {
  font-family: 'Ktcfast', sans-serif !important;
  font-size: clamp(13px, 1.3vw, 17px) !important;
  font-weight: 700 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  padding: clamp(10px, 1.2vh, 14px) clamp(32px, 4vw, 52px) !important;
  height: auto !important;
  border-radius: 12px !important;
  box-shadow: 0 6px 25px rgba(0, 166, 230, 0.35) !important;
  transition: all 0.3s ease !important;
}

.consent-accept-btn:hover {
  box-shadow: 0 8px 35px rgba(0, 166, 230, 0.5) !important;
  transform: translateY(-2px);
}

@media (max-width: 600px) {
  .consent-card {
    width: 92%;
    border-radius: 16px;
  }

  .consent-card-header {
    font-size: 15px;
    padding: 12px 16px;
  }

  .consent-card-content {
    padding: 16px 14px;
    gap: 12px;
  }
}
</style>
